import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { ControlledRadioGroup } from "~/components/form/controlled-inputs";
import { CheckboxGroupField } from "~/components/form/checkbox-group-field";
import {
  PreferredCoachingStyleAndFormatSchema,
  coachingApproachesField,
  coachingFormatsAndApproachesStep,
  coachingFormatsFields,
} from "~/lib/schemas/coach-discovery";

import type { PreferredCoachingStyleAndFormatForm } from "~/lib/schemas/coach-discovery";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import { createNoIndexMeta } from "~/lib/shared/meta";

function DiscoveryStep3() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm(
    PreferredCoachingStyleAndFormatSchema,
    3,
  );
  const { handleSubmit, control, formState } = form;
  const { errors, isSubmitting, isValid } = formState;

  const onSubmit = (_data: PreferredCoachingStyleAndFormatForm) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={coachingFormatsAndApproachesStep.title} />

      <DiscoveryStep.Card>
        <FormField
          label={coachingFormatsFields.subTitle || ""}
          labelSize="xl"
          error={errors.coachingFormats?.message}
        >
          <ControlledRadioGroup
            control={control}
            name="coachingFormats"
            options={
              coachingFormatsFields.options?.map(({ value, label }) => ({
                value,
                label,
              })) || []
            }
            className="flex flex-col gap-y-4"
          />
        </FormField>
      </DiscoveryStep.Card>

      <DiscoveryStep.Card>
        <FormField
          labelSize="xl"
          error={errors.coachingApproaches?.message}
          label={coachingApproachesField.subTitle}
        >
          <CheckboxGroupField
            name="coachingApproaches"
            control={control}
            options={coachingApproachesField.options || []}
            exclusiveOptions={["Not sure yet"]}
            maxSelections={2}
          />
        </FormField>
      </DiscoveryStep.Card>

      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        disabled={!isValid}
        loading={isSubmitting}
      />
    </form>
  );
}

export const Route = createFileRoute("/_public/discovery/steps/3/")({
  head: () =>
    createNoIndexMeta(
      "Step 3: Coaching Style & Format – Dream Coach Match",
      "Choose your preferred coaching style and format in our coach discovery process",
    ),
  component: DiscoveryStep3,
});
